// extracted by mini-css-extract-plugin
export default {"result":"bFSojU79wIsym6GQ1F7h","list":"ARh4mxcY6d8rWT5Cz81q","button":"o7lqBX9wX2LIUSGVVkhA","footer":"g7dJmz7mHgNx9vPVmZC5","item":"_xi98Jolw3psYsTtsCIe"};